export class BaseDto {
  public id?: string
  public createdAt?: Date
  public updatedAt?: Date
}